import { j as o } from "./AccesRecoveryIcon-CUPieIxT.js";
const r = () => /* @__PURE__ */ o.jsx("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ o.jsx(
  "path",
  {
    d: "M17.74 37.005V8.438l-9.965 9.966a2.255 2.255 0 1 1-3.189-3.189l13.82-13.819a2.255 2.255 0 0 1 3.188 0l13.818 13.818a2.255 2.255 0 1 1-3.189 3.19L22.26 8.437l-.002 28.567a2.259 2.259 0 0 1-4.517 0",
    fill: "currentColor"
  }
) });
export {
  r as A
};
